<template>
  <v-form ref="loginForm" v-model="valid" lazy-validation @submit="onSubmit">
    <v-card width="400" height="400" align="center" class="cardSignin">
      <v-card-title primary-title class="title">{{
        $t("signin.title")
      }}</v-card-title>

      <v-card-text>
        <v-text-field
          v-model="email"
          :error-messages="emailErrors"
          :label="$t('signin.email')"
          id="input-email"
          required
          color="black"
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
        ></v-text-field>

        <v-text-field
          v-model="password"
          :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
          :type="show ? 'text' : 'password'"
          @click:append="show = !show"
          :error-messages="passwordErrors"
          :label="$t('signin.password')"
          id="input-password"
          required
          color="black"
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
        ></v-text-field>
      </v-card-text>

      <div v-if="errorLogin.checkLogin">
        {{ errorLogin.checkLogin }}
      </div>

      <v-card-actions primary-title class="justify-center cardAction">
        <vue-recaptcha
          ref="invisibleRecaptcha"
          @verify="onVerify"
          @expired="onExpired"
          :sitekey="sitekey"
          :loadRecaptchaScript="true"
          :language="this.$i18n.locale"
        >
          <v-btn color="error" class="button" :disabled="!valid" type="submit">
            {{ $t("signin.title") }}
          </v-btn>
        </vue-recaptcha>
      </v-card-actions>

      <v-card-actions class="cardActionForgot">
        <v-flex class="link">
          <router-link :to="'/' + this.$i18n.locale + '/forgot-password'">
            {{ $t("signin.forgotPassword") }}
          </router-link>
        </v-flex>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";

import router from "@/router/index";
import { validationMixin } from "vuelidate";
import { required, email, minLength } from "vuelidate/lib/validators";
import authService from "@/services/planning/AuthService";
import LogInUser from "@/models/LogInUser";

export default {
  mixins: [validationMixin],
  validations: {
    password: { required, minLength: minLength(8) },
    email: { required, email },
    form: ["email", "password"],
  },
  components: {
    VueRecaptcha,
  },
  data: () => ({
    sitekey: "default",
    show: false,
    password: "",
    email: "",
    errorLogin: { checkLogin: null },
    sucessfulServerResponse: "",
    serverError: "",
    valid: false,
  }),
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push(this.$t("errorFrontEnd.invalidEmail"));
      !this.$v.email.required &&
        errors.push(this.$t("errorFrontEnd.requiredEmail"));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength &&
        errors.push(this.$t("errorFrontEnd.shortPassword"));
      !this.$v.password.required &&
        errors.push(this.$t("errorFrontEnd.requiredPassword"));
      return errors;
    },
  },
  created() {
    this.sitekey = process.env.VUE_APP_GOOGLE_CAPTCHA_SITE_KEY;
    if ($cookies.get("auth")) {
      router.push("/" + this.$i18n.locale + "/calendar");
    }
  },
  methods: {
    // Start Captcha
    onSubmit() {
      this.$refs.invisibleRecaptcha.execute();
    },
    onVerify(captchaToken) {
      this.$refs.invisibleRecaptcha.reset();
      this.submit(captchaToken);
    },
    onExpired() {
      this.$refs.invisibleRecaptcha.reset();
    },

    // End Captcha

    submit(captchaToken) {
      if (this.$v.form.$invalid) {
        this.password = "";
        this.email = "";
      } else {
        const logInUser = new LogInUser(
          this.email,
          this.password,
          captchaToken
        );
        authService.login(logInUser).then((data) => {
          switch (data.status) {
            case 200:
              router.push("/" + this.$i18n.locale + "/calendar");

              break;
            case 401:
              this.errorLogin.checkLogin = this.$t("signin.error401");

              break;
            case 404:
              this.errorLogin.checkLogin = this.$t("signin.error404");

              break;
            case 422:
              this.errorLogin.checkLogin = this.$t("signin.error422");

              break;
            default:
              this.errorLogin.checkLogin = this.$t("signin.errorLogin");

              break;
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#styled-input {
  height: 40px;
  font-size: 15pt;
}
.styled-input label[for] {
  height: 40px;
  font-size: 15pt;
}

.cardSignin {
  padding: 2rem 2rem;
}

.button {
  width: 100%;
}

.cardAction {
  padding: 0 1rem;
}

.cardActionForgot {
  padding: 1rem;
}

.v-application .title {
  font-size: 1.5rem !important;
  justify-content: center;
}

.link {
  text-align: right;
}

.link > a {
  color: gray;
}
</style>
